import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import {
  GrossIncomeDescription,
  OtherIncomeDescription,
} from '../../../../components/FormDescriptions';
import {
  buildGroupedCurrencySchemaProperties,
  buildGroupedCurrencyUIProperties,
} from '../../../../definitions';
import content from '../../../../locales/en/content.json';
import { strWithYear } from '../../../../utils/helpers';

const TITLE_TEXT = strWithYear(content['household-info--vet-income-title']);

const SCHEMA_CONFIG = [
  {
    dataField: 'veteranGrossIncome',
    subtitle: content['household-info--vet-income-gross-title'],
    description: GrossIncomeDescription,
    label: strWithYear(content['household-info--vet-income-gross-label']),
  },
  {
    dataField: 'veteranNetIncome',
    subtitle: content['household-info--vet-income-net-title'],
    description: content['household-info--vet-income-net-description'],
    label: strWithYear(content['household-info--vet-income-net-label']),
  },
  {
    dataField: 'veteranOtherIncome',
    subtitle: content['household-info--vet-income-other-title'],
    description: OtherIncomeDescription,
    label: strWithYear(content['household-info--vet-income-other-label']),
  },
];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    ...buildGroupedCurrencyUIProperties(SCHEMA_CONFIG),
  },
  schema: {
    type: 'object',
    required: [
      'view:veteranGrossIncome',
      'view:veteranNetIncome',
      'view:veteranOtherIncome',
    ],
    properties: buildGroupedCurrencySchemaProperties(SCHEMA_CONFIG),
  },
};
